import ModelApi from "./ModelApi";

class FacilityApi extends ModelApi {
	constructor(token, clientID, onUnauthorized) {
		super(token, clientID, onUnauthorized);
		this.baseUrl = this.getBaseUrl() + "facilities/";
	}

	async list(onSuccess, onError, onUnauthorized) {
		const response = await fetch(this.baseUrl , {
				method: "GET",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: this.getToken(),
				},
			})

			if (response.ok) {
				const data = await response.json()
				onSuccess(data)
			} else if (response.status === 401) {
				this.onUnauthorized()
			} else if (response.status === 403) {
				onUnauthorized()
			} else {
				onError()
			}

		}

	saveTrendPreferences(facility, appliedKeys, appliedFilters, onSuccess, onError) {
		const data = {
			trends_applied_keys: appliedKeys,
			trends_applied_filters: appliedFilters
		}

        this.Patch(
            facility,
			data,
            onSuccess, 
			onError, 
		)
		
    }
}

export default FacilityApi;
